/* import __COLOCATED_TEMPLATE__ from './send-to-salesforce-overlay.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import BaseFilterBlockPopover from 'predicates/components/filter-block/base-filter-block-popover';
import { action } from '@ember/object';

export default class SendToSalesforceOverlay extends BaseFilterBlockPopover {
  @action
  onDone() {
    this.componentAttrs.action.justAdded = false;
    this.hideDropdownOverlay();
  }
}
